export function index(array, toKey, toValue?) {
	let map = new Map()
	if (typeof toKey == 'string') {
		let key = toKey
		toKey = value => value[key]
	}
	for (let i = 0, l = array.length; i < l; i++) {
		let element = array[i]
		map.set(toKey(element), toValue ? toValue(element) : element)
	}
	return map
}

export class Cache implements Map {
	map = new Map()
	get(key, createIfMissing?) {
		let value = this.map.get(key)
		if (value === undefined && createIfMissing) {
			this.map.set(key, value = createIfMissing())
		}
		return value
	}
	delete(key) {
		return this.map.delete(key)
	}
	has(key) {
		return this.map.has(key)
	}
	set(key, value) {
		return this.map.set(key, value)
	}
	[Symbol.iterator]() {
		return this.map[Symbol.iterator]()
	}
	values() {
		return this.map.values()
	}
	keys() {
		return this.map.keys()
	}
	get size() {
		return this.map.size
	}
}